import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Features } from "@/components/site/Features";
import { BuiltByMemories } from "@/components/site/BuiltByMemories";
import { LaunchingSoon } from "@/components/site/LaunchingSoon";
import { Sunset } from "@/components/site/Sunset";
import { Pricing } from "@/components/site/Pricing";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen overflow-x-clip bg-[#030507] text-[#E6EDF4]">
      <Nav />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <BuiltByMemories />
        <LaunchingSoon />
        <Sunset />
        <Pricing />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
